// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QMnfM","instruction":"styles_instruction__s1a7D"};